/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDocuments = /* GraphQL */ `
  query GetDocuments(
    $search: String
    $precision: Int
    $topLeft: LocationBound
    $bottomRight: LocationBound
  ) {
    getDocuments(
      search: $search
      precision: $precision
      topLeft: $topLeft
      bottomRight: $bottomRight
    ) {
      ... on Locations {
        count
        location {
          lat
          lon
        }
      }
      ... on User {
        id
        name
        currentGeopoint {
          lat
          lon
        }
        tags
        picture
        createdAt
        tagFeatured
      }
    }
  }
`;
export const getProfileViews = /* GraphQL */ `
  query GetProfileViews($profileId: String) {
    getProfileViews(profileId: $profileId)
  }
`;
